import { useCallback, useContext } from "react";
import { WebsocketContext } from "./websocket-context";
import { WebsocketHookType } from "./websocket-context.types";

export const useWebsocket = (): WebsocketHookType => {
  const { websocketTexts, setWebsocketTexts } = useContext(WebsocketContext);

  const createWebsocketTexts = useCallback(
    (newMessage: string[]): void => {
      setWebsocketTexts(newMessage);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [websocketTexts]
  );

  const deleteWebsocketTexts = useCallback((): void => {
    setWebsocketTexts(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websocketTexts]);

  return {
    websocketTexts,
    createWebsocketTexts,
    deleteWebsocketTexts,
  };
};
